import React, { FC, ReactElement } from 'react';
import { observer } from 'mobx-react-lite';
import { ExperimentStatus } from '@yakoffice/publisher-types';
import style from '../../components/tables/filters/table-filters.module.sass';
import filterIcon from '../../components/tables/filters/filter_list.svg';

interface PropsType {
    variant: string,
    statuses: ExperimentStatus[],
    handleStatusToggle: (status: ExperimentStatus) => void,
    nameSearch: ReactElement | string
}

export const ExperimentStatusToggleDropDownButton: FC<PropsType> = observer((props) => {

    return <div className={style.tableFilters}>
        <img src={filterIcon} alt="" className={style.filterIcon} />
        {Object.values(ExperimentStatus).map(status => {
            return status.length > 0 && <div key={`toggle-${status}`}
                                             className={`${style.status} ${props.statuses.includes(status) ? style.active : style.inactive}`}
                                             onClick={() => props.handleStatusToggle(status)}>{props.statuses.includes(status) &&
                <i className="fas fa-check" />}
                {status}</div>;
        })}
        <div className={style.tableSearch}>{props.nameSearch}</div>
    </div>;
});
